module.exports = __webpack_public_path__ + "static/media/room3.30629bde.jpg";